import { render, staticRenderFns } from "./DefaultsByLocale.vue?vue&type=template&id=3c34feba&scoped=true&"
import script from "./DefaultsByLocale.vue?vue&type=script&lang=js&"
export * from "./DefaultsByLocale.vue?vue&type=script&lang=js&"
import style0 from "./DefaultsByLocale.vue?vue&type=style&index=0&id=3c34feba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c34feba",
  null
  
)

export default component.exports